import React from 'react';

export default ({ children, ...props }) => <div className='zt-inputs--label zt-p1'>{children}</div>;